import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const inputStyle = {
  width: '100%',
  height: 48,
  padding: '0 14px',
  borderRadius: 10,
  border: '1px solid #e5e7eb',
  fontSize: 14,
  outline: 'none',
  boxSizing: 'border-box',
};

export default function MarketForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/market/auth/forgot-password`, { email: email.trim() });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Request failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Link to="/market" style={{ textDecoration: 'none', display: 'inline-block' }}>
            <img
              src="/doorly-market-logo.png"
              alt="Doorly Market"
              style={{ height: '36px', width: 'auto', display: 'block', margin: '0 auto' }}
            />
          </Link>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '16px 0 4px' }}>Forgot Password</h1>
          <p style={{ color: '#6b7280', fontSize: 13 }}>
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        <div style={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: 16, padding: 28 }}>
          {done ? (
            <div style={{ textAlign: 'center', color: '#374151', fontSize: 14, lineHeight: 1.6 }}>
              If an account exists for <strong>{email}</strong>, a password reset link has been sent.
              The link expires in 1 hour.
              <div style={{ marginTop: 18 }}>
                <Link to="/market/login" style={{ color: '#3a6ad9', fontWeight: 600 }}>Back to sign in</Link>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              {error && (
                <div style={{ marginBottom: 14, padding: '10px 14px', borderRadius: 10, backgroundColor: '#fff5f6', border: '1px solid #ffd6db', color: '#ff082f', fontSize: 13 }}>
                  {error}
                </div>
              )}
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={inputStyle}
              />
              <button
                type="submit"
                disabled={loading}
                style={{
                  marginTop: 18,
                  width: '100%',
                  height: 48,
                  borderRadius: 100,
                  border: 'none',
                  backgroundColor: '#3a6ad9',
                  color: '#fff',
                  fontWeight: 700,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}
        </div>

        <p style={{ textAlign: 'center', fontSize: 13, color: '#6b7280', marginTop: 18 }}>
          <Link to="/market/login" style={{ color: '#3a6ad9' }}>Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
